import { render, staticRenderFns } from "./uebersicht.vue?vue&type=template&id=15091760&"
import script from "./uebersicht.vue?vue&type=script&lang=js&"
export * from "./uebersicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports